import { supabase } from '../supabase';

export const createFileOpening = async (data) => {
  const { data: fileOpening, error } = await supabase
    .from('file_openings')
    .insert([data])
    .select();

  if (error) {
    throw new Error(error.message);
  }

  return fileOpening ? fileOpening[0] : null;
};

export const getFileOpenings = async ({ limit = 10, offset = 0, sortBy = 'date', sortOrder = 'desc', searchTerm = '' }) => {
  let query = supabase
    .from('file_openings')
    .select('id,forename, surname, date', { count: 'exact' })
    .is('deleted_at', null)
    .order(sortBy, { ascending: sortOrder === 'asc' })
    .order('id', { ascending: false })
    .range(offset, offset + limit - 1);

  if (searchTerm) {
    query = query.or(`forename.ilike.%${searchTerm}%,surname.ilike.%${searchTerm}%`);
  }

  const { data: fileOpenings, error, count } = await query;

  if (error) {
    throw new Error(error.message);
  }

  return { fileOpenings, count };
};

export const getFileOpeningRegisterEntries = async ({ limit = 10, offset = 0, sortBy = 'date', sortOrder = 'desc', searchTerm = '', startDate = '', endDate = '' }) => {
  let query = supabase
    .from('file_openings')
    .select('id, title, dob, forename, surname, date, number_street, city, country, postal_code, matter_type, id_carried_out, evidence_relied_upon', { count: 'exact' })
    .is('deleted_at', null)
    .order(sortBy, { ascending: sortOrder === 'asc' })
    .order('id', { ascending: false })
    .range(offset, offset + limit - 1);

  if (searchTerm) {
    query = query.or(`forename.ilike.%${searchTerm}%, surname.ilike.%${searchTerm}%`);
  }

  if (startDate) {
    query = query.gte('date', startDate);
  }

  if (endDate) {
    query = query.lte('date', endDate);
  }

  const { data: fileOpenings, error, count } = await query;

  if (error) {
    throw new Error(error.message);
  }

  return { fileOpenings, count };
};

export const getFileOpeningById = async (id) => {
  const { data: fileOpening, error } = await supabase
    .from('file_openings')
    .select('*')
    .eq('id', id)
    .single();

  if (error) {
    throw new Error(error.message);
  }

  return fileOpening;
};

export const updateFileOpening = async (id, data) => {
  const { data: fileOpening, error } = await supabase
    .from('file_openings')
    .update(data)
    .eq('id', id);

  if (error) {
    throw new Error(error.message);
  }

  return fileOpening ? fileOpening[0] : null;
};

export const deleteFileOpening = async (id) => {
  const { data, error } = await supabase
    .from('file_openings')
    .update({ deleted_at: new Date() })
    .eq('id', id);

  if (error) {
    throw new Error(error.message);
  }

  return data;
};

export const getFileOpeningsWithBalance = async ({
  limit = 10,
  offset = 0,
  sortBy = 'date',
  sortOrder = 'desc',
  searchTerm = ''
} = {}) => {

  let query = supabase
    .from('file_openings_balance') // Using the view we created
    .select('*', { count: 'exact' })
    .order(sortBy, { ascending: sortOrder === 'asc' })
    .order('id', { ascending: false })
    .range(offset, offset + limit - 1);

  if (searchTerm) {
    query = query.or(`forename.ilike.%${searchTerm}%,surname.ilike.%${searchTerm}%,title.ilike.%${searchTerm}%`);
  }

  const { data: fileOpenings, error, count } = await query;

  if (error) {
    throw new Error(error.message);
  }

  return { fileOpenings, count };
};